import { Component, Host, Optional, inject } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenav } from '@angular/material/sidenav';
import { Route, Router, RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { MpsPermissionHelper } from '../../helpers/mps-permission.helper';
import { MpsUserService } from '../../services/mps-user.service';

@Component({
  selector: 'mps-app-navigation',
  templateUrl: './mps-navigation.component.html',
  styleUrls: ['./mps-navigation.component.scss'],
  imports: [TranslateModule, MatMenuModule, RouterModule],
})
export class MpsNavigationComponent {
  private readonly routes: Route[] = [];
  private userService = inject(MpsUserService);
  private router = inject(Router);

  constructor(@Host() @Optional() private sidenav: MatSidenav) {
    this.routes = this.router.config;
  }

  public getRoutes(): Route[] {
    return this.routes;
  }

  public close(): void {
    if (this.sidenav) {
      this.sidenav.close();
    }
  }

  isMenuItemDisplayed(route: Route): boolean {
    const user = this.userService.getUserSubject().getValue();
    if (!user) {
      return false;
    }

    const hasTitle = route.data?.['title'];
    const canUserActivate = MpsPermissionHelper.canUserActivate(user, route);

    return hasTitle && canUserActivate;
  }

  isChildRouteActive(route: Route): boolean {
    if (!route || !route.children) {
      return false;
    }
    // Check if any child route is active
    return route.children.some((child: Route) =>
      this.router.isActive(this.router.createUrlTree([route.path, child.path]), {
        paths: 'subset',
        queryParams: 'ignored',
        fragment: 'ignored',
        matrixParams: 'ignored',
      })
    );
  }
}
